// extracted by mini-css-extract-plugin
export default {"pagination":"index_pagination__kX8-M","tHeader":"index_tHeader__RH+-2","tBodys":"index_tBodys__-KcRd","divideLine":"index_divideLine__UTziO","noData":"index_noData__K5LDd"};